import { render } from "./pet.vue?vue&type=template&id=3a1bf9d4"
import script from "./pet.vue?vue&type=script&lang=js"
export * from "./pet.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__